import { render, staticRenderFns } from "./dayshiftSelectorBody.vue?vue&type=template&id=388d08bc"
import script from "./dayshiftSelectorBody.vue?vue&type=script&lang=js"
export * from "./dayshiftSelectorBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports